export default {
  eventsFromStore(mutation, ganttInstance) {
    if (mutation.type === 'columns/updateUserCustomValues') {
      const hasGanttId = mutation.payload.userCustomValues.some(customValueData => ganttInstance.isTaskExists(customValueData.taskId));

      if (hasGanttId) {
        ganttInstance.render();
      }
    }

    if (mutation.type === 'columns/setValuesLoaded') {
      const loaded = mutation.payload;

      if (loaded) {
        ganttInstance.render();
      }
    }
  },
};
